<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					*ngIf="activeStatus <= 3 ||activeStatus==6 "
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.BOOKING_NUMBER' | translate }}
				</td>
				<td
					*ngIf="activeStatus <= 3 ||activeStatus==6"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.AMOUNT' | translate }}
				</td>

				<td
					*ngIf="activeStatus==6"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.CASHBACK' | translate }}
				</td>
				<td
					*ngIf="activeStatus <= 3"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.CLIENT_NAME_NUMBER' | translate }}
				</td>
				<td
					*ngIf="activeStatus == 4 || activeStatus == 5"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.CLIENT_NAME_NUMBER' | translate }}
				</td>
				<td
					*ngIf="activeStatus == 4 || activeStatus == 5"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						activeStatus == 4
							? ('FINANCE.FINANCE_LIST.ADDED_FUND' | translate)
							: ('FINANCE.FINANCE_LIST.SUBTRACTED_FUND' | translate)
					}}
				</td>

				<td
					*ngIf="activeStatus <= 3 ||activeStatus==6"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.SP_NAME_BRANCH' | translate }}
				</td>
				<td
					*ngIf="activeStatus <= 3 ||activeStatus==6"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.DATE_TIME' | translate }}
				</td>

				<td
					*ngIf="activeStatus == 4 || activeStatus == 5"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'FINANCE.FINANCE_LIST.DATE_TIME' | translate }}
				</td>
				<td
					*ngIf="activeStatus == 4 || activeStatus == 5"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'reason' | translate }}
				</td>

				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<ng-container *ngIf="activeStatus <= 3 || activeStatus==6"
				><tr
					class="{{ !last ? 'border-b-[1px] border-[#D9DBE9]' : '' }} pt-[6px]"
					*ngFor="
						let last = last;
						let payment;
						of: listData?.payments?.items
							| paginate
								: {
										itemsPerPage: financialFilter?.paging?.pageSize,
										currentPage: financialFilter?.paging?.pageNumber,
										totalItems: totalCount
								  }
					"
				>
					<td
						class="cursor-pointer text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ payment?.appointmentSerialNumber }}
						<span *ngIf="payment?.hasPromoCode"
							><img src="./assets/images/tag.svg" alt=""
						/></span>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular rtl:pr-[22px]"
					>
						<p class="text-font-16 mb-0">
							<span>
								{{
									translate.currentLang == 'ar'
										? payment?.currency?.name?.ar
										: payment?.currency?.name?.en
								}}
							</span>
							<span *ngIf="activeStatus !=6">{{ payment?.paidAmount }}</span>
							<span *ngIf="activeStatus !=6" class="mx-1"> {{ 'FINANCE.FINANCE_LIST.OF' | translate }}</span>
							<span >{{ payment?.totalAmount }}</span>
						</p>
						<p class="text-font-14 mb-0">
							{{
								translate.currentLang == 'ar'
									? payment?.paymentMethod?.nameAr
									: payment?.paymentMethod?.nameEn
							}}
							|
							<span
								[ngClass]="
									payment?.paymentStatus == 0
										? 'text-[#B3261E]'
										: 'text-[#00BA88]'
								"
							>
								{{
									payment?.paymentStatus == 0
										? ('STATUS.UNPAID' | translate)
										: payment?.paymentStatus == 1
										? ('STATUS.PAID' | translate)
										: payment?.paymentStatus == 2
										? ('STATUS.UNCOMPLETEDPAYMENT' | translate)
										: ('STATUS.REFUNDED' | translate)
								}}</span
							>
						</p>
					</td>
					<td *ngIf="activeStatus ==6"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{payment?.paidAmount}} 		{{
						translate.currentLang == 'ar'
							? payment?.currency?.name?.ar
							: payment?.currency?.name?.en
					}}
				</td>
					<td *ngIf="activeStatus !=6"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p class="mb-0">{{ payment?.clientName }}</p>
						<p class="text-font-14 text-medium-gray mb-0">
							{{ payment?.clientMobile }}
						</p>
					</td>

					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p class="mb-0">{{ payment?.providerName }}</p>
						<p class="text-font-14 text-medium-gray mb-0">
							{{ payment?.branchName }}
						</p>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p class="mb-0">{{ payment.date | date : 'dd/MM/yyyy' }}</p>
						<p class="text-font-14 text-medium-gray mb-0">
							{{ payment.date | date : 'hh:mm a' }}
						</p>
					</td>

					<td
						class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<span
							(click)="redirect(payment?.appointmentId)"
							class="inline-block max-mobile:w-[20px] w-[16px] text-end"
						>
							<img
								[src]="'assets/images/view.svg'"
								alt=""
								class="inline-block cursor-pointer"
							/>
						</span>
					</td></tr
			></ng-container>
			<ng-container *ngIf="activeStatus == 4 || activeStatus == 5">
				<tr
					*ngFor="
						let fund of listData?.funds?.items
							| paginate
								: {
										itemsPerPage: financialFilter?.paging?.pageSize,
										currentPage: financialFilter?.paging?.pageNumber,
										totalItems: totalCount
								  }
					"
				>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p>{{ fund?.actorName }}</p>
						<p class="text-font-14 text-medium-gray">
							<!-- {{ fund?.clientMobile }} -->
						</p>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p>
							<span>{{
								translate.currentLang == 'en'
									? fund?.currency?.name.en
									: fund?.currency?.name.ar
							}}</span>
							{{ fund?.amount }}
						</p>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p>{{ fund.date | date : 'dd/MM/yyyy' }}</p>
						<p class="text-font-14 text-medium-gray">
							{{ fund.date | date : 'hh:mm a' }}
						</p>
					</td>

					<td
						*ngIf="activeStatus == 4 || activeStatus == 5"
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<p>{{ fund?.reason }}</p>
					</td>
					<td
						class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<a (click)="redirect(fund?.actorId, fund?.actor)">
							<span class="inline-block max-mobile:w-[20px] w-[16px] text-end">
								<img
									[src]="'assets/images/view.svg'"
									alt=""
									class="inline-block cursor-pointer"
								/>
							</span>
						</a>
					</td>
				</tr>
			</ng-container>


		</tbody>
	</table>
</div>
